(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Contador"] && !Shopify.designMode) return;
  try {
    

  let nuraMountFrame = null;
  function nuraScheduleMount() {
    if (nuraMountFrame !== null) return;
    nuraMountFrame = window.requestAnimationFrame(() => {
      nuraMountFrame = null;
      const target = document.querySelector('[data-nura-countdown-slot]');
      const chosen = new Map();
      document.querySelectorAll('nura-loop-countdown[data-section-id]').forEach(timer => {
        const home = document.getElementById('NuraCountdownHome-' + timer.dataset.sectionId);
        if (!home || !home.isConnected) { timer.remove(); return; }
        const previous = chosen.get(timer.dataset.sectionId);
        if (!previous) { chosen.set(timer.dataset.sectionId, timer); return; }
        if (home.parentElement.contains(timer)) {
          previous.remove(); chosen.set(timer.dataset.sectionId, timer);
        } else { timer.remove(); }
      });
      chosen.forEach(timer => {
        const home = document.getElementById('NuraCountdownHome-' + timer.dataset.sectionId);
        const origin = home.closest('.shopify-section');
        if (timer.dataset.placement === 'product' && target) {
          if (timer.parentElement !== target) target.appendChild(timer);
          if (origin) origin.classList.add('nura-countdown-section--mounted');
        } else {
          if (origin) origin.classList.remove('nura-countdown-section--mounted');
          if (timer.previousElementSibling !== home) home.insertAdjacentElement('afterend', timer);
        }
      });
    });
  }
  document.addEventListener('shopify:section:load', nuraScheduleMount);
  document.addEventListener('shopify:section:reorder', nuraScheduleMount);
  document.addEventListener('shopify:section:unload', event => {
    document.querySelectorAll('nura-loop-countdown[data-section-id]').forEach(timer => {
      const home = document.getElementById('NuraCountdownHome-' + timer.dataset.sectionId);
      const origin = home && home.closest('.shopify-section');
      if (origin === event.target) {
        timer.remove();
      } else if (event.target.contains(timer) && home) {
        if (origin) origin.classList.remove('nura-countdown-section--mounted');
        home.insertAdjacentElement('afterend', timer);
      }
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', nuraScheduleMount, { once: true });
  } else { nuraScheduleMount(); }

  if (!customElements.get('nura-loop-countdown')) {
    class NuraLoopCountdown extends HTMLElement {
      connectedCallback() {
        this.stop();
        this.duration = Math.max(1, Number(this.dataset.duration) || 1) * 1000;
        this.key = 'nura-loop:v1:' + location.pathname + ':' + this.dataset.key + ':' + this.duration;
        this.nodes = {};
        this.querySelectorAll('[data-nt]').forEach(node => { this.nodes[node.dataset.nt] = node; });
        this.clock = this.querySelector('[role="timer"]');
        this.start = Date.now();
        if (this.dataset.mode === 'global') {
          this.start = 0;
        } else {
          try {
            const raw = localStorage.getItem(this.key);
            const saved = raw === null ? NaN : Number(raw);
            if (Number.isFinite(saved) && saved > 0 && saved <= this.start) {
              this.start = saved;
            } else {
              localStorage.setItem(this.key, String(this.start));
            }
          } catch (error) {}
        }
        this.tick = this.renderTime.bind(this);
        this.renderTime();
        nuraScheduleMount();
        this.interval = window.setInterval(this.tick, 250);
      }

      disconnectedCallback() {
        this.stop();
      }

      stop() {
        if (this.interval) window.clearInterval(this.interval);
        this.interval = null;
      }

      renderTime() {
        const elapsed = Math.max(0, Date.now() - this.start);
        const remaining = Math.ceil((this.duration - elapsed % this.duration) / 1000);
        const hours = String(Math.floor(remaining / 3600)).padStart(2, '0');
        const minutes = String(Math.floor(remaining % 3600 / 60)).padStart(2, '0');
        const seconds = String(remaining % 60).padStart(2, '0');
        const digits = { h0: hours[0], h1: hours[1], m0: minutes[0], m1: minutes[1], s0: seconds[0], s1: seconds[1] };
        Object.entries(digits).forEach(([key, value]) => {
          const node = this.nodes[key];
          if (node && node.textContent !== value) node.textContent = value;
        });
        const label = hours + ' ' + this.dataset.hoursLabel + ', ' + minutes + ' ' + this.dataset.minutesLabel + ', ' + seconds + ' ' + this.dataset.secondsLabel;
        if (this.clock && this.clock.getAttribute('aria-label') !== label) this.clock.setAttribute('aria-label', label);
      }
    }
    customElements.define('nura-loop-countdown', NuraLoopCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
